import React from 'react';
import { Checkbox } from '../../../../components/Checkbox';
import { ColorPicker } from '../../../../components/ColorPicker';
import { DropdownSelect } from '../../../../components/Dropdown';
import { TextInput } from '../../../../components/TextInput';
import { BasePdfComponent, PdfFontFamily, PdfComponentFontProperties } from '../../PdfComponent';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';

interface WithFontProps extends BasePdfComponent {
  font?: PdfComponentFontProperties;
}

interface PdfTemplateComponentFontController {
  onChange: (font: PdfComponentFontProperties | undefined) => void;
  font: PdfComponentFontProperties | undefined;
  checkboxLabel?: string;
}

export default function PdfTemplateComponentFont<T>({
  component,
  controller,
}: {
  component: WithFontProps;
  controller?: PdfTemplateComponentFontController;
}) {
  const { updateComponent, documentProperties } = usePdfTemplateContext<T>();
  const used = controller?.font || component.font || documentProperties.font;

  const handleChange = (font: PdfComponentFontProperties | undefined) => {
    if (controller) {
      controller.onChange(font);
    } else {
      updateComponent(component.id, { font });
    }
  };

  return (
    <>
      <Checkbox
        value={!controller?.font && !component.font}
        label={controller?.checkboxLabel || 'Use document font style'}
        onChange={checked => handleChange(checked ? undefined : used)}
      />
      {(controller?.font || component.font) && (
        <div className='grid grid-cols-3 gap-2 overflow-hidden'>
          <div className='col-span-2 overflow-hidden'>
            <DropdownSelect<PdfFontFamily>
              label={'Font family'}
              textBuilder={f => f}
              value={used.family}
              items={Object.values(PdfFontFamily)}
              onSelect={family => handleChange({ ...used, family })}
            />
          </div>

          <div className='col-span-1'>
            <TextInput
              value={used.size}
              label={'Font size'}
              type={'number'}
              onChange={value => handleChange({ ...used, size: value ? Number(value) : used.size })}
            />
          </div>
          <div className='col-span-3'>
            <ColorPicker
              label={'Font color'}
              color={used.color}
              onChange={color => handleChange({ ...used, color })}
              tooltip={'Select font color'}
            />
          </div>
        </div>
      )}
    </>
  );
}
